module.exports = __webpack_public_path__ + "static/img/10.2f738c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/sp/10.png
// module id = 6m+h
// module chunks = 0